import axios from 'axios';

const isProdEnvironment = import.meta.env.MODE === 'production';

const clickstreamAPI = axios.create({
  baseURL: isProdEnvironment
    ? import.meta.env.REACT_APP_PROD_CLICKSTREAM_COLLECTOR_URL
    : import.meta.env.REACT_APP_DEV_CLICKSTREAM_COLLECTOR_URL,
  headers: {
    'x-api-key': isProdEnvironment
      ? import.meta.env.REACT_APP_PROD_CLICKSTREAM_X_API_KEY
      : import.meta.env.REACT_APP_DEV_CLICKSTREAM_X_API_KEY,
  },
  withCredentials: false,
});

export default clickstreamAPI;
